module.exports = __webpack_public_path__ + "static/media/countryImage.9e7d6e51.svg";